<template>
	<div>
		<el-card class="box-card">
			<el-form :inline="true">
				<el-form-item label="用户">
					<el-select filterable clearable v-model="listQuery.search.uid" clearable>
						<el-option v-for="item in re_all" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="订单号">
					<el-input placeholder="请填写" v-model="listQuery.search.order_num" clearable> </el-input>
				</el-form-item>
				<el-form-item label="状态:">
					<el-select v-model="listQuery.search.state" clearable>
						<el-option label="未审核" value="0"></el-option>
						<el-option label="审核通过" value="1"></el-option>
						<el-option label="审核失败" value="2"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-button type="primary" icon="el-icon-search" @click="keySearch">搜索</el-button>
			<el-button type="primary" plain @click="resetSearch">重置搜索</el-button>
			<span style="margin-left: 30px">提现金额：<span style="color: #F56C6C;"> ¥ {{money}}</span></span>
		</el-card>

		<div style="margin-top:30px">
			<el-table v-loading="loading" :data="data_list" stripe style="width: 100%" size="small">
				<el-table-column type="expand">
					<template slot-scope="props">
						<el-form label-position="left" inline class="demo-table-expand">
							<el-form-item label="订单号:">
								<span>{{props.row.order_num}}</span>
							</el-form-item>
							<el-form-item v-if="props.row.state == 2" label="拒绝原因:">
								<span>{{props.row.err_msg}}</span>
							</el-form-item>
							<el-form-item label="审核时间:">
								<template slot-scope="{row}">
									<span>{{ props.row.sh_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
								</template>
							</el-form-item>
						</el-form>
					</template>
				</el-table-column>
				<el-table-column prop="id" label="ID"> </el-table-column>
				<el-table-column prop="uid" label="用户">
					<template slot-scope="{row}">
						<span>{{row.uid_name}}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="order_num" label="订单号"> </el-table-column> -->
				<el-table-column prop="type_init" label="类型"> </el-table-column>
				<el-table-column prop="account" label="提现账号"> </el-table-column>
				<el-table-column prop="money" label="提现金额"> </el-table-column>

				<el-table-column prop="create_time" label="创建时间">
					<template slot-scope="{row}">
						<span>{{ row.create_time | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</span>
					</template>
				</el-table-column>
				<el-table-column label="状态">
					<template slot-scope="{row}">
						<el-tag :type="row.state_color">
							{{ row.state_init}}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="180">
					<template v-if="row.state == 0" slot-scope="{row,$index}">
						<el-popconfirm @confirm="pass(row.id)" @onConfirm="pass(row.id)" title="确定已经线下转账？">
							<el-button icon="el-icon-check" type="primary" size="mini" slot="reference">通过</el-button>
						</el-popconfirm>
						<el-button icon="el-icon-close" @click="refuse(row.id)" type="danger" size="mini">拒绝</el-button>
					</template>
				</el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.row"
				@pagination="getList" />
			<!-- 拒绝模态框 -->
			<el-dialog title="拒绝" :visible.sync="is_show_refuse" width="30%">
				<el-form label-position="left">
					<el-form-item label="拒绝理由:">
						<el-col :span="18">
							<el-input rows="4" type="textarea" v-model="refuse_data.msg"></el-input>
						</el-col>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="is_show_refuse = false">返回</el-button>
					<el-button :loading="this.$store.state.ajaxLoading" type="primary" @click="refuse2()">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import {
		withdrawaShlList,
		withdrawalSh
	} from '@/api/sign_admin'
	import request from '@/tool/request'
	import {
		parseTime,alertMsg
	} from '@/tool/index'
	import Qs from 'qs'
	import Pagination from '@/components/Pagination' // 基于分页的二级包装
	import Dtp from '@/components/Ele/dateTimePicker.vue' // 时间选择组件
	export default {
		components: {
			Pagination,
			Dtp
		},
		data() {
			return {
				total: 0, // 总条数
				listQuery: null,
				is_show_search: false, // 搜索模态框
				data_list: [], // 表格数据
				loading: true,
				is_show_refuse: false,
				refuse_data: {
					'state': 2,
					'msg': ''
				},
				money: '0.00',
				re_all: [],
			};
		},
		filters: {
			parseTime,
		},
		created() {
			this.resetSearchData()
			this.getList()
		},
		methods: {
			keySearch() { // 搜索
				this.listQuery.page = 1
				this.getList()
			},

			resetSearchData() { // 重置listQuery搜索数据
				this.listQuery = {
					page: 1,
					row: 10,
					search: [],
				}
			},
			// 重置搜索
			resetSearch() {
				this.resetSearchData()
				this.getList()
			},
			// 获取列表数据
			getList() {
				this.loading = true;
				withdrawaShlList(Qs.stringify(this.listQuery)).then(response => {
					let r = response.result;
					this.data_list = r.items;
					this.total = r.total;
					if (this.listQuery.page == 1) {
						this.money = r.money;
						this.re_all = r.re_all;
					}
					this.loading = false;
				})
			},
			pass(val) {
				let post = {
					'id': val,
					'state': 1,
				}
				withdrawalSh(Qs.stringify(post)).then(response => {
					this.getList();
					alertMsg(this, '操作成功', 'success');
				})
			},
			refuse(val) {
				this.refuse_data.id = val;
				this.refuse_data.msg = '';
				this.is_show_refuse = true;
			},
			refuse2() {
				this.$store.commit('setAjaxLoading', true);
				withdrawalSh(Qs.stringify(this.refuse_data)).then(response => {
					this.is_show_refuse = false;
					this.getList();
					alertMsg(this, '操作成功', 'success');
				})
			}
		}
	}
</script>
